<template>
    <div class="card">
        <div class="card-header">Questionnaire</div>
        <div class="card-body">
            <div v-for="(q, index) in questions" :key="q.code">
                <b-row>
                    <b-col cols="12" lg="12">
                        <BaseSelector v-model="questionResponses[index].response"
                              :v="$v.questionResponses.$each[index].response"
                              :label="q.questionText"
                              slug="t"
                              :options ="opts.yesNoOptions" />
                    </b-col>
                </b-row>
                <b-row v-if="q.triggerAddlResponse === true && questionResponses[index].response === 'Y'">
                    <b-col cols="12" lg="12">
                        <BaseTextInput v-model="questionResponses[index].additionalResponse"
                                       :v="$v.questionResponses.$each[index].additionalResponse"
                                       slug="additionalResponse"
                                       :label="q.addlResponseText"
                                       :key="index"
                                       :setId="'qAddlResponse'+index"
                        />
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>

</template>
<script>
    import { commonOptions } from '@/mixins/commonOptions.js'
    import BaseTextInput from '@/components/templates/input/BaseTextInput.vue'
    import { required, requiredIf, maxLength } from 'vuelidate/lib/validators'
    import axios from "axios"
    import axiosRetry from 'axios-retry'

    axiosRetry(axios, { retries: 3,
        retryDelay: axiosRetry.exponentialDelay  })

    export default {
        created() {
            this.loadQuestions();
        },
        data: () => {
            return {
                questions: [],
                questionResponses: []
            }
        },
        props: {
            renewalApplication: {
                type: Object,
                default () {
                    return {
                    }
                }
            },
        },
        mixins: [
            commonOptions
        ],
        components: {
            BaseTextInput,
        },
        validations() {
            return {
                questionResponses: {
                    $each: {
                        response: { required },
                        additionalResponse: {
                            required: requiredIf((object) => {
                                let q = this.questions.filter(q => q.code == object.question)[0];
                                return q.triggerAddlResponse === true && q.addlResponseRequired === true && object.response === 'Y'
                            }),
                            maxLength: maxLength(250)
                        }
                    }
                },
                form: ['questionResponses']
            }
        },
        methods: {
            loadQuestions() {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/Questions/public`, { ignoreHeader: true })
                    .then(response => {
                        this.questions = response.data
                        for (let q of this.questions) {                            
                            this.questionResponses.push({
                                response: null,
                                additionalResponse: null,
                                question: q.code,
                                application: null
                            })
                        }

                        if (this.renewalApplication.questionResponses != null) {
                            for (let q of this.renewalApplication.questionResponses) {
                                for (let q2 of this.questionResponses) {
                                    if (q.question === q2.question) {
                                        q2.response = q.response
                                        q2.additionalResponse = q.additionalResponse
                                    }
                                }
                            }
                        }
                    })
                
            },
            validate() {
                this.$v.form.$touch();
                var isValid = !this.$v.form.$invalid
                this.$emit('on-validate', this.$data, isValid)
                return isValid
            }
        },
        watch: {
            renewalApplication() {
                if (this.renewalApplication.questionResponses !== null) {
                    for (let q of this.renewalApplication.questionResponses) {
                        for (let q2 of this.questionResponses) {
                            if (q.question === q2.question) {
                                q2.response = q.response
                                q2.additionalResponse = q.additionalResponse
                            }
                        }
                    }
                }
            }
        },
    }
</script>
<style>
.custom-select {
    width: 15em;
}
</style>